import React from 'react';
import { Field } from 'formik';
import c from 'classnames';
import { useTranslation } from 'react-i18next';

import withMapping from '@uncinc/uncinc-react-kitchen-sink/dist/Context/withMapping';
import GenericFormElement from '@uncinc/uncinc-react-kitchen-sink/dist/components/Form/GenericFormElement';

import './style.scss';

const CustomNumberField = (props) => {
  const {
    title,
    required,
    requiredError,
    description,
    placeholder,
    fieldName,
    touched,
    error,
    value,
    displayRequiredIndicator,
    onChange,
    className,
    wrapperClassName,
    disabled = false,
    min,
    max,
    step,
    prefix,
    ...fieldProps
  } = props;

  const { t } = useTranslation();

  const handleChange = (e) => {
    const { handleChange } = props;
    if (handleChange) {
      handleChange(e);
    }

    if (onChange) {
      onChange(e);
    }
  };

  const validation = (value) => {
    let error;
    if (required && !value) {
      error = requiredError || t('webform.components.number.required', 'webform.required', 'webform_required');
    }

    if (min && parseInt(value) < min) {
      error = t('webform.components.number.min', { min });
    }

    if (max && parseInt(value) > max) {
      error = t('webform.components.number.max', { max });
    }

    if (step && step !== null) {
      const decimals = value.toString().split('.')[1];

      if (!decimals) {
        return;
      }

      if (1 / 10 ** decimals.length < step) {
        error = t('webform.components.number.step', { step: step.toString().split('.')[1].length });
      }
    }

    return error;
  };


  return (
    <GenericFormElement
      className={c("TextField", wrapperClassName)}
      title={title}
      required={required}
      description={description}
      fieldName={fieldName}
      touched={touched}
      error={error}
      displayRequiredIndicator={displayRequiredIndicator}
    >
      {prefix && (
        <div className="TextField__prefix">
          {prefix}
        </div>
      )}
      <Field
        className={c(className, { 'error': error && touched })}
        name={fieldName}
        type="number"
        value={parseFloat(value)}
        placeholder={placeholder}
        validate={validation}
        onKeyUp={handleChange}
        disabled={disabled}
        min={min}
        max={max}
        step={step}
        {...fieldProps}
      />
    </GenericFormElement>
  );
};

export default withMapping(CustomNumberField);
